/**
 * OpponentDragConfig — Live-tunable values for spectating opponent dice drag.
 *
 * Exported as a mutable object so the debug panel can change values at runtime
 * without a recompile. OpponentDiceManager.update() reads these every frame.
 */
export const OpponentDragConfig = {
  /** Client-side interpolation delay (ms). Render the drag pose at
   *  "now - delay" by interpolating between buffered snapshots that bracket
   *  that timestamp. Higher = smoother under jitter, but more perceived lag. */
  interpolationDelayMs: 85,

  /** Exponential follow rate (per second) used when renderTime has run past
   *  the newest buffered snapshot. Higher = catches up faster but closer to
   *  a snap; lower = smoother but laggier. 12 → ~58ms half-life. */
  tailFollowRate: 0,
};
